/** O logotipo principal, no lugar da palavra "Unik" em texto puro. */
export function BrandMark({
  variant,
  className = "h-4",
}: {
  /** creme — fundo escuro (território admin). vinho — fundo creme (território client). */
  variant: "creme" | "vinho";
  className?: string;
}) {
  return (
    <img
      src={`/brand/logotipo-principal-${variant}.png`}
      alt="Unik"
      className={`${className} w-auto`}
    />
  );
}
